import { useEffect } from "react";

import { destroyFancybox, initFancybox } from "@/lib/fancybox";

export const useFancybox = (): void => {
  useEffect(() => {
    initFancybox();

    return () => {
      destroyFancybox();
    };
  }, []);
};
